<!--
  Stable Rete shell.

  Rete mounts this component as an Angular custom element, so keep UI markup,
  dialogs, and user interactions in moulding-node-content.component.html.
  This shell only projects Rete's socket/control hosts into that normal Angular
  child component.
-->
<app-moulding-node-content [data]="data" (layoutChanged)="scheduleRendered()">
  <!--
    These hosts stay in the Rete shell because refComponent emits the render and
    unmount events Rete uses to create sockets and controls.
  -->
  <div node-ports>
    @for (
      output of data.outputs | keyvalueimpure: sortByIndex;
      track output.key
    ) {
      <div class="output">
        <div class="output-title">
          {{ output.value?.label }}
        </div>
        <div
          class="output-socket"
          refComponent
          [data]="{
            type: 'socket',
            side: 'output',
            key: output.key,
            nodeId: data.id,
            payload: output.value?.socket,
            seed: seed,
          }"
          [emit]="emit"
        ></div>
      </div>
    }

    @for (input of data.inputs | keyvalueimpure: sortByIndex; track input.key) {
      <div class="input">
        <div
          class="input-socket"
          refComponent
          [data]="{
            type: 'socket',
            side: 'input',
            key: input.key,
            nodeId: data.id,
            payload: input.value?.socket,
            seed: seed,
          }"
          [emit]="emit"
        ></div>
        @if (!input.value?.control || !input.value?.showControl) {
          <div class="input-title">
            {{ input.value?.label }}
          </div>
        }
        <div
          class="input-control"
          [style.display]="
            input.value?.control && input.value?.showControl ? '' : 'none'
          "
          refComponent
          [data]="{ type: 'control', payload: input.value?.control }"
          [emit]="emit"
        ></div>
      </div>
    }
  </div>
</app-moulding-node-content>
